export default __webpack_public_path__ + "static/m-sizzling3-2ba32224df6298fdb5fc7cefdcf4a3f1.jpg";